import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FileAddIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7 4C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H10.0967C10.6489 20 11.0967 20.4477 11.0967 21C11.0967 21.5523 10.6489 22 10.0967 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2H13.5858C14.1162 2 14.6249 2.21071 15 2.58579L19.4142 7C19.7893 7.37507 20 7.88378 20 8.41421V13.0158C20 13.5681 19.5523 14.0158 19 14.0158C18.4477 14.0158 18 13.5681 18 13.0158V10H15C13.3431 10 12 8.65685 12 7V4H7ZM14 4.41421V7C14 7.55228 14.4477 8 15 8H17.5858L14 4.41421ZM16.5 15C17.0523 15 17.5 15.4477 17.5 16V17.5H19C19.5523 17.5 20 17.9477 20 18.5C20 19.0523 19.5523 19.5 19 19.5H17.5V21C17.5 21.5523 17.0523 22 16.5 22C15.9477 22 15.5 21.5523 15.5 21V19.5H14C13.4477 19.5 13 19.0523 13 18.5C13 17.9477 13.4477 17.5 14 17.5H15.5V16C15.5 15.4477 15.9477 15 16.5 15Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

FileAddIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FileAddIcon);
